import React from 'react';
import { makeStyles } from '@material-ui/core';
import { compose } from 'ramda';
import { reduxForm, InjectedFormProps, FieldArray } from 'redux-form';
import { BoxWrapper, Button } from 'components/Base';
import { PlatformType } from 'store/modules/Platform/types';
import Platforms from './Platforms';

const useStyles = makeStyles({
  main: {
    minWidth: '22rem'
  },
  btnContainer: {
    display: 'flex',
    marginTop: '2rem',
    width: '100%',
    justifyContent: 'space-between'
  },
  content: {
    padding: '1rem'
  }
});

interface Props extends InjectedFormProps {
  platforms: PlatformType[];
  closeModal: () => void;
}

const PlatformHoldings = ({ closeModal, handleSubmit, submitting }: Props) => {
  const classes = useStyles();

  return (
    <BoxWrapper
      className={classes.main}
      title="Existing platform holdings"
      closeModal={closeModal}
    >
      <div className={classes.content}>
        <form onSubmit={handleSubmit}>
          <FieldArray
            name="holdings"
            component={Platforms}
            rerenderOnEveryChange
          />
          <div className={classes.btnContainer}>
            <Button color="primary" onClick={closeModal}>
              Cancel
            </Button>
            <Button isLoading={submitting} type="submit">
              Update
            </Button>
          </div>
        </form>
      </div>
    </BoxWrapper>
  );
};

export default compose(
  reduxForm({
    form: 'platformHoldings'
  })
)(PlatformHoldings);
